import builder from '../builder';
import Dryer from '../../streamline-icons/bold/dryer.svg';

export default builder('IconDryerBold', Dryer);
